import React, { useEffect, useMemo, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';

import Card from '../../../CustomComponents/Card';
import CustomAlertModel from '../../../CustomComponents/CustomAlertModel';

import { appTheme } from '../../../../helpers/utils/Utils';
import { addLineBreaks, LineBreaksSpan } from '../../../../utils';
import logFirebaseEvents from '../../../LogFirebaseEvents';
import BancorpPrivacyPolicy from '../BancorpPrivacyPolicy';
import DepositAgreement from '../DepositAgreement';
import ElectronicAgreement from '../ElectronicAgreement';
import SavingsAgreement from '../SavingsAgreement';
import PatriotAct from '../PatriotAct';

const AgreementsAndDisclosures = ({
  handleContinueClick,
}) => {

  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [showPolicys, setShowPolicys] = useState('terms');

  const signUpkudzuPlusTrue = useSelector(
    state => state.isSignUpKudzuplusTrue
  );

  const checkboxes = useSelector(
    state => state.signupTermsAndConditionCheckbox
  );

  const personalInfo = useSelector(state => state.signUpPersonelInfo);
  const isFromSmiOne = useSelector((state) => state.fromSmiOne);
  const appThemeData = appTheme(signUpkudzuPlusTrue);
  const button1Ref = useRef(null);

  const [isEnroll, setIsEnroll] = useState(false);
  const [showModel, setShowModel] = useState(false);
  const [highlightMsg, setHighlightMsg] = useState('');
  const [headerMsg, setheaderMsg] = useState('');
  const [subHeaderMsg, setSubHeaderMsg] = useState('');
  const [btn1Exists, setBtn1Exists] = useState(false);
  const [btn2Exists, setBtn2Exists] = useState(false);
  const [btn1Text, setBtn1Text] = useState('');
  const [btn2Text, setBtn2Text] = useState('');
  const [btn1TypeAcpt, setBtn1TypeAcpt] = useState(false);
  const [modelImage, setModelImage] = useState('');
  const [isBorderNone, setisBorderNone] = useState(true);
  const [showErrorImg, setshowErrorImg] = useState(false);
  const [largeImage, setLargeImage] = useState(false);

  const modalTitleBase = "font-serif-pro modal-title lg:text-[32px] md:text-[28px] sm:text-[23px] text-[27px] lg:leading-[38px] md:leading-[32px] sm:leading-[30px] font-normal text-[var(--modal-text-heading-clr)]";
  const highlightMsgStyles = `${modalTitleBase} leading-[31px]`;
  const headerMsgStyles = `${modalTitleBase} leading-[37px]`;
  const subHeaderMsgStyles = "font-hanken-grotesk text-[var(--modal-text-heading-clr)] modal-title lg:text-[14px] md:text-[14px] sm:text-[15px] text-[17px] font-300";

  const headingStyles = "font-serif-pro lg:text-[31px] md:text-[26px] sm:text-[22px] text-[25px] lg:leading-[38px] md:leading-[33px] sm:leading-[30px] leading-[31px] font-[400]";

  const isContinueEnabled = useMemo(() => {
    if (isEnroll) {
      return checkboxes?.savings_account_aggrement;
    }
    return (
      checkboxes?.privacy_user &&
      checkboxes?.deposit_savings
    );
  }, [checkboxes, isEnroll]);

  useEffect(() => {
    if (isEnroll && checkboxes?.savings_account_aggrement && button1Ref.current) {
      button1Ref.current.focus();
    }
  }, [isEnroll, checkboxes?.savings_account_aggrement]);

  const toggleCheckbox = (keyArray) => {
    keyArray.forEach((key) => {
      dispatch({
        type: 'UPDATE_SIGN_UP_TERMS_CHECKBOX',
        payload: {
          key,
          value: !checkboxes[key]
        }
      });
    });
  };

  const showPolicy = (type) => {
    setShowPolicys(type);
  };

  const showAlertModal = (showModel, highlightMsg, headerMsg, subHeaderMsg, btn1Exists, btn2Exists, btn1Text, btn2Text, btn1TypeAcpt, modelImage, showErrorImg, isBorderNone, largeImage) => {
    setshowErrorImg(showErrorImg);
    setisBorderNone(isBorderNone);
    setShowModel(showModel);
    setHighlightMsg(highlightMsg);
    setheaderMsg(headerMsg);
    setSubHeaderMsg(subHeaderMsg);
    setBtn1Exists(btn1Exists);
    setBtn2Exists(btn2Exists);
    setBtn1Text(btn1Text);
    setBtn2Text(btn2Text);
    setBtn1TypeAcpt(btn1TypeAcpt);
    setModelImage(modelImage);
    setLargeImage(largeImage);
  };

  const closeModel = () => {
    setShowModel(false);
  };

  const onAcptBtnClick = () => {
    if (btn1Text === t('enroll_savings_account')) {
      setIsEnroll(true);
      closeModel();
      logFirebaseEvents("Enroll_Savings_Account", "Enroll_Savings_Account_Clicked", "Enroll_Savings_Account_Clicked", "");
    }
  };

  const onCancelBtnClick = () => {
    if (btn2Text === t('maybe_later')) {
      closeModel();
      dispatch({ type: "SIGN_UP_TERMS_AND_CONDITIONS", payload: { signUpTermsAndConditions: checkboxes } });

      const updatedPersonalInfo = {
        ...personalInfo,
        isEsignAccepted: checkboxes?.electronic_aggrement || checkboxes?.privacy_user,
        IsPrivacyPolicyAccepted: checkboxes?.privacy_user,
        IsCHAgreementAccepted: true,
        CreateSavings: false
      };
      dispatch({ type: 'SIGN_UP_PERSONEL_INFO', payload: { signUpPersonelInfo: updatedPersonalInfo } });

      handleContinueClick();
      logFirebaseEvents("Enroll_Savings_Account", "Maybe_later_Clicked", "Maybe_later_Clicked", "", "");
    }
  };

  const onContinueClick = () => {
    logFirebaseEvents(
      "Terms_and_Conditions",
      "Terms_and_Conditions_Continue_Clicked",
      "Terms_and_Conditions_Continue_Clicked",
      "",
      ""
    );

    if (!isContinueEnabled) {
      return;
    }

    if (!checkboxes?.savings_account_aggrement && !isEnroll) {
      showAlertModal(
        true,
        "",
        <>
          <span className='text-[var(--modal-text-highlight)]'>
            {signUpkudzuPlusTrue ? t("send_email_verify_code_great") : ""}
          </span>
          {" "}{t("great_would_u_like_two_enroll")}
        </>,
        signUpkudzuPlusTrue
          ? "Earn 1.26% Annual Percentage Yield (APY) on your Kudzu+ savings account balance."
          : <p className='font-[600] text-[16px]'>{addLineBreaks(t('set_aside_money_for_the_things_that_matter'))}</p>,
        true,
        true,
        t('enroll_savings_account'),
        t('maybe_later'),
        true,
        signUpkudzuPlusTrue
          ? require('../../../../assets/kudzu-plus-images/enrollPlusIcon.png')
          : require('../../../../assets/images/illo_beneficiary_4x.png'),
        false,
        true,
        signUpkudzuPlusTrue ? true : false
      );
      return;
    }

    if (isEnroll && !checkboxes?.savings_account_aggrement) {
      return;
    }

    dispatch({ type: "SIGN_UP_TERMS_AND_CONDITIONS", payload: { signUpTermsAndConditions: checkboxes } });

    const updatedPersonalInfo = {
      ...personalInfo,
      isEsignAccepted: checkboxes?.electronic_aggrement || checkboxes?.privacy_user,
      IsPrivacyPolicyAccepted: checkboxes?.privacy_user,
      IsCHAgreementAccepted: true,
      CreateSavings: checkboxes?.savings_account_aggrement || false
    };
    dispatch({ type: 'SIGN_UP_PERSONEL_INFO', payload: { signUpPersonelInfo: updatedPersonalInfo } });

    handleContinueClick();
  };

  return (
    <div className="sm:px-[6%] md:py-10 sm:py-12 flex flex-wrap sm:flex-nowrap scroll-mt-0">

      {showPolicys === 'terms' && (
        <Card
          footerBgDisabled={true}
          cardHeight={'auto'}
          isWhiteForSignup={appThemeData.isWhiteBgForCard}
          isDarkForKudzu={appThemeData.isDarkBgForCard}
          backgroundColor={'--modalcard-bg'}
          CardRadius={true}
          header={true}
          footer={false}
          heading={
            <h1 className={`${headingStyles} text-[#FFFFFF]`}>
              {isEnroll ? t('great_exclamation') : t('almost_there')}
            </h1>
          }
          subheading={
            <p className={`${headingStyles} text-[#94C3E8]`}>
              {isEnroll
                ? isFromSmiOne
                  ? addLineBreaks(t("review_savings"))
                  : signUpkudzuPlusTrue
                    ? t("terms_and_condition_heading5")
                    : t("terms_and_conditions_savings_basic")
                : t('review_terms_to_open_account')
              }
            </p>
          }
          Cardcaption={isEnroll ? LineBreaksSpan(t("terms_and_condition_saving_subheading")) : t('agreements_disclosures')}
          footerContent={
            <div className="flex justify-end md:px-[5rem] sm:px-[4rem] px-[2.5rem] py-[4rem]">
              <button
                ref={button1Ref}
                type="button"
                disabled={!isContinueEnabled}
                className={`font-hanken-grotesk sm:font-bold font-[600] lg:text-[18px] md:text-[17px] sm:text-[14px] text-[16px]
                  cursor-pointer flex items-center
                  ${isContinueEnabled
                    ? 'text-[var(--transactions-filter-blue-text)]'
                    : `text-[var(--twofac-modal-btn-clr-disabled)] ${appThemeData ? 'opacity-75' : ''}`
                  }`}
                onClick={onContinueClick}
              >
                {t('continue')}
                <img
                  src={isContinueEnabled ? appThemeData.arrowWhiteTwofac : appThemeData.SignupNextArrow}
                  className={`${signUpkudzuPlusTrue ? '' : 'w-3 h-3'} ml-2`}
                  alt=""
                />
              </button>
            </div>
          }
          >
          <p className='h-[43px] text-[var(--modal-text-heading-clr)] font-[500] md:text-[20px] sm:text-[12px] text-[16px] font-hanken-grotesk sm:mt-[10px] mt-[25px]'>{t('accept_terms_signup')}</p>
          <div className='mt-10 md:w-[460px] sm:w-[301px] w-full'>
              {!isEnroll && (
              <>
              <div
                className="
                bg-[#EFEFE8]
                rounded-[6px]
                p-6
                mb-14
              "
              >
                <p className="font-hanken-grotesk font-semibold
                uppercase tracking-[0.2em] text-[13px] leading-[13px]
                text-[#5E5E5B] mb-3">
                  {t('usa_patriot_act_notice')}
                </p>

                <p className="
                    font-hanken-grotesk
                    font-normal
                    text-[16px]
                    leading-[22px]
                    tracking-normal
                    text-[var(--modal-text-heading-clr)]
                  ">
                  {t('federal_law_requires')}
                  <button
                    type="button"
                    className="
                      ml-1
                      font-hanken-grotesk
                      font-bold
                      text-[16px]
                      leading-[22px]
                      tracking-normal
                      underline
                      text-[var(--modal-text-highlight)]
                      cursor-pointer
                    "
                    onClick={() => showPolicy('patriot')}
                  >
                    {t('learn_more')}
                  </button>
                </p>
              </div>

              <p className="font-hanken-grotesk font-semibold uppercase tracking-[0.2em]
                text-[13px] leading-[13px] text-[var(--terms-text-clr)] mb-6">
                {t('terms_conditions')}
              </p>

              <div className="flex mb-4">
                  <input
                    id="privacy-user-checkbox"
                    name="privacy_user"
                    type="checkbox"
                    className="checkbox-custom-organic checkbox-no-shadow checkbox-signup-terms cursor-pointer"
                    value=""
                    checked={checkboxes?.privacy_user}
                    onChange={() =>
                      toggleCheckbox(['privacy_user', 'electronic_aggrement'])
                    }
                    autoFocus
                  />
                  <span className="font-hanken-grotesk ml-4 sm:ml-2 md:ml-4 md:text-sm sm:text-[12px] text-[14px] md:font-[540] sm:font-medium font-normal text-[var(--modal-text-heading-clr)]">
                    <label htmlFor="privacy-user-checkbox" className="cursor-pointer">
                      {t('read_and_agree')}
                    </label>
                    <span
                      role="button"
                      tabIndex="0"
                      className="ml-1 text-[var(--modal-text-highlight)] font-bold cursor-pointer"
                      onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); showPolicy('electronic'); } }}
                      onClick={(e) => { e.preventDefault(); showPolicy('electronic'); }}
                    >
                      {t('electronic_communications_agreement')}
                    </span>
                    {t('and')}
                    <span
                      role="button"
                      tabIndex="0"
                      className="ml-1 text-[var(--modal-text-highlight)] cursor-pointer font-bold"
                      onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); showPolicy('privacy'); } }}
                      onClick={(e) => { e.preventDefault(); showPolicy('privacy'); }}
                    >
                      {t('bancorp_privacy_notice')}
                    </span>.
                  </span>
              </div>

              <div className="flex mb-4 mt-10">
                  <input
                    id="deposit-savings-checkbox"
                    name="deposit_savings"
                    type="checkbox"
                    className="checkbox-custom-organic checkbox-no-shadow checkbox-signup-terms cursor-pointer"
                    value=""
                    checked={checkboxes?.deposit_savings}
                    onChange={() =>
                      toggleCheckbox(['deposit_savings'])
                    }
                  />
                  <span className="font-hanken-grotesk ml-4 sm:ml-2 md:ml-4 md:text-sm sm:text-[12px] text-[14px] md:font-[540] sm:font-medium font-normal text-[var(--modal-text-heading-clr)]">
                    <label htmlFor="deposit-savings-checkbox" className="cursor-pointer">
                      {signUpkudzuPlusTrue
                        ? t('Kudzu_Plus_DDA_Para')
                        : t('electing_to_spending_account')
                      }{' '}
                    </label>
                    <span
                      role="button"
                      tabIndex="0"
                      className="ml-1 text-[var(--modal-text-highlight)] cursor-pointer font-bold"
                      onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); showPolicy('deposit'); } }}
                      onClick={(e) => { e.preventDefault(); showPolicy('deposit'); }}
                    >
                      {signUpkudzuPlusTrue
                        ? t('deposit_account_agreement_plus')
                        : t('deposit_account_agreement')
                      }
                    </span>
                  </span>
              </div>

              <p className="font-hanken-grotesk mt-10 font-normal text-[12px] leading-[16px] md:text-[16px] md:leading-[22px] text-[var(--modal-text-heading-clr)]">
                {t('virtual_card_disclaimer')}
              </p>

              <div className="pb-[8rem]"></div>
              </>
              )}

              {isEnroll && (
                <>
                <div className="flex mb-4 mt-16">
                  <input
                    id="savings-account-checkbox"
                    name="savings_account_aggrement"
                    type="checkbox"
                    className="checkbox-custom-organic checkbox-no-shadow checkbox-signup-terms cursor-pointer"
                    value=""
                    checked={checkboxes?.savings_account_aggrement}
                    onChange={() =>
                      toggleCheckbox(['savings_account_aggrement'])
                    }
                    autoFocus
                  />
                  <span className="font-hanken-grotesk ml-4 sm:ml-2 md:ml-4 md:font-[540] md:text-sm sm:text-[12px] text-[14px] sm:font-medium font-normal text-[var(--modal-text-heading-clr)]">
                    <label htmlFor="savings-account-checkbox" className="cursor-pointer">
                      {signUpkudzuPlusTrue ? t('electing_open_savings_account') : t('electing_open_savings_account_basic')}
                    </label>
                    <span
                      role="button"
                      tabIndex="0"
                      className="ml-1 text-[var(--modal-text-highlight)] cursor-pointer font-bold"
                      onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); showPolicy('savings'); } }}
                      onClick={(e) => {
                        e.preventDefault();
                        showPolicy('savings');
                        logFirebaseEvents("TermsConditions", "SavingsAccountAgreementClicked.", "SavingsAccountAgreementClicked", "");
                      }}
                    >
                      {signUpkudzuPlusTrue ? t('kudzu_savings_account_aggrement') : t('Savings_Account_Agreement')}
                    </span>.
                  </span>
                </div>

                <p className={`font-hanken-grotesk sm:font-[540] font-normal md:text-[16px] sm:text-[12px] text-[14px]
                   text-[var(--terms-text-clr)]
                   pb-[15rem] pt-12`}>
                {t('by_tapping_continue_i_am_confirming')} </p>
                </>
              )}
          </div>
        </Card>
      )}

      {showPolicys === 'privacy' && (
        <BancorpPrivacyPolicy handleClick={showPolicy} />
      )}
      {showPolicys === 'deposit' && (
        <DepositAgreement handleClick={showPolicy} />
      )}
      {showPolicys === 'electronic' && (
        <ElectronicAgreement handleClick={showPolicy} />
      )}
      {showPolicys === 'savings' && (
        <SavingsAgreement handleClick={showPolicy} />
      )}
      {showPolicys === 'patriot' && (
        <PatriotAct handleClick={showPolicy} />
      )}

      <CustomAlertModel
        isOpen={showModel}
        onClose={closeModel}
        image={modelImage}
        highlightMsg={<p className={highlightMsgStyles}>{highlightMsg}</p>}
        HeaderMsg={<p className={headerMsgStyles}>{headerMsg}</p>}
        subHeaderMsg={<p className={subHeaderMsgStyles}>{subHeaderMsg}</p>}
        btn1Exists={btn1Exists}
        btn2Exists={btn2Exists}
        btn1Text={btn1Text}
        btn2Text={btn2Text}
        btn1TypeAcpt={btn1TypeAcpt}
        onAcptBtnClick={onAcptBtnClick}
        onCancelBtnClick={onCancelBtnClick}
        showErrorImg={showErrorImg}
        isBorderNone={isBorderNone}
        largeImage={largeImage}
      />

    </div>
  );
};

export default AgreementsAndDisclosures;
